module.exports = __webpack_public_path__ + "static/chefhands_web-cfc50bbd4f62157e666acbea5a135228.jpg";